import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../services/localiser";
import {plano} from "../../../models/plano";
import {proyecto} from "../../../models/proyecto";
import {PlanoService} from "../../../services/plano.service";

@Component({
  selector: 'app-delete-floorplan',
  templateUrl: './delete-floorplan.component.html',
  styleUrls: ['./delete-floorplan.component.css']
})
export class DeleteFloorplanComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteFloorplanComponent>, @Inject(MAT_DIALOG_DATA) public data: {floorplan: plano, proyecto: proyecto},
              private planoService: PlanoService, public localiser: Localiser) { }

  ngOnInit(): void {
    console.log(this.data)
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  deleteFloorplan() {
    this.planoService.delete(this.data.floorplan.idPlano).subscribe(result => {
      this.onCancelClick();
    })
  }

}
